// extracted by mini-css-extract-plugin
export default {"statsContainer":"UnpaidReceiptsStatsPanel_statsContainer__qzfqW","statsItem":"UnpaidReceiptsStatsPanel_statsItem__nolsG"};